// Angular
import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

// External
import { NgxPermissionsService } from 'ngx-permissions';
import { Subscription } from 'rxjs';

// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from './@metronic/core/_base/layout';
import { locale as chLang } from './i18n/ch';
import { locale as deLang } from './i18n/de';

// language list
import { locale as enLang } from './i18n/en';
import { locale as esLang } from './i18n/es';
import { locale as frLang } from './i18n/fr';
import { locale as jpLang } from './i18n/jp';

// Utils
import { DateUtil } from './core/utils/date-util';
import { installKtWizardZoneBridge } from './core/utils/kt-zone-bridge';

// Service
import { TokenStorageService } from './state/core/services/token-storage/token-storage.service';
import { AuthStoreService } from './state/modules/auth/auth-store.service';

// Constant
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { AUTH_METHOD_CONSTANTS } from './constants/ngrx-store/auth';
import { MessagingService } from './core/services/messaging.service';
import { ShiftInfoMainService } from './modules/main/shift-info/services/shift-info-main.service';

@Component({
  standalone: false,
  // tslint:disable-next-line:component-selector
  selector: 'body[kt-root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  // Public properties
  title = 'Metronic';
  loader: boolean;
  initialURL = '';
  message = null;
  isActiveTab = false;
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  // temp permissions
  private _hubConnection;

  constructor(
    private readonly router: Router,
    private readonly translationService: TranslationService,
    private readonly layoutConfigService: LayoutConfigService,
    private readonly authStoreService: AuthStoreService,
    private readonly permissionsService: NgxPermissionsService,
    private httpClient: HttpClient,
    private zone: NgZone,
    private readonly splashScreenService: SplashScreenService,
    private readonly tokenStorageService: TokenStorageService) {

    // register translations
    this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);
    this.initialURL = window.location.pathname;
  }


  ngOnInit(): void {
    // Patch the global KTWizard so every `wizard.on('beforeNext'|'beforePrev'|…)`
    // callback registered anywhere in the app runs inside the Angular zone.
    // One install covers all 20+ wizard.on(…) call sites across *-action modals.
    installKtWizardZoneBridge(this.zone);

    const self = this;
    window.onfocus = function () {
      self.isActiveTab = true;
      // console.log(self.isActiveTab);
    };

    window.onblur = function () {
      self.isActiveTab = false;
      // console.log(self.isActiveTab);
    };
    if (!environment.log) {
      // console.log = function() {};
    }

    this.zone.runOutsideAngular(() => {
      window.addEventListener('storage', function (e) {
        if (e.key === 'business' || e.key === 'user') {
          let oldBusiness = e.oldValue && e.key === 'business' ? JSON.parse(e.oldValue) : {};
          let newBusiness = e.newValue &&  e.key === 'business' ? JSON.parse(e.newValue) : {};
          let oldUser = e.oldValue && e.key === 'user' ? JSON.parse(e.oldValue) : {};
          let newUser = e.newValue && e.key === 'user' ? JSON.parse(e.newValue) : {};
          if (!oldBusiness) {
            oldBusiness = {};
          }
          if (!newBusiness) {
            newBusiness = {};
          }
          if (!oldUser) {
            oldUser = {};
          }
          if (!newUser) {
            newUser = {};
          }
          if (!self.isActiveTab) {
            if ((e.key === 'business' &&  oldBusiness.business_id !== newBusiness.business_id) || (e.key === 'user' && oldUser.user_id !== newUser.user_id)) {
              location.reload();
            }
          }
        }
      });
    })

    // this.httpClient.get('https://notificationv2test.iqcheckpoint.com/api/v1/notification/test').subscribe();
    // this.signalRConnection();
    // this.signalREvents();
    // set default timezone
    DateUtil.setDefaultTimeZone();

    // enable/disable loader
    this.loader = this.layoutConfigService.getConfig('loader.enabled');

    const routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && this.splashScreenService) {
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('kt-page--loaded');
        }, 500);
      }
    });
    this.unsubscribe.push(routerSubscription);
    this.setPermission();

  }

  // signalRConnection() {
  //   this._hubConnection = new signalR.HubConnectionBuilder()
  //     .withUrl(environment.signalR_URL)
  //     .configureLogging(signalR.LogLevel.Information)
  //     .build();
  // }


  /**
   * To send to the url when the page was refreshed
   */
  permissionRetrived() {
    setTimeout(() => {
      if (this.initialURL && this.initialURL.split('/') && this.initialURL.split('/').slice(1)) {
        this.router.navigate(this.initialURL.split('/').slice(1));
      }
    }, 2000);
  }

  /**
   * Gets called when page gets refresh to load the permission
   */
  setPermission() {
    if (this.tokenStorageService.validateAccessToken() && this.tokenStorageService.validateBusinessToken()) {
      // this.authStoreService.dispatchAuthCommon({
      //   module: AUTH_METHOD_CONSTANTS.PERMISSION,
      //   callback: this.permissionRetrived.bind(this),
      // });
    }
  }

  ngOnDestroy() {
    // this.leaveGroup('1', '1');
    this.unsubscribe.forEach(sb => sb.unsubscribe());
  }
}
